import Api from 'api'

const config = {
  baseURL: '/api/app/v1/benchmarks',
}

const api = new Api(config)

api.fetchAll = ({ ...rest }) => api.get('', { ...rest })
api.setSeen = ({ ...rest }) => api.post('/seen', { ...rest })
api.activate = ({ ...rest }) => api.post('/activate', { ...rest })
api.archive = ({ ...rest }) => api.post('/archive', { ...rest })

//@TODO remove if deprecated or unused
// api.getSettings = () => api.get('/settings')

export default api
